import { Route } from '@core/routing/routes/enums/route';
import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { RouteTitleProvider } from '@core/routing/titles/providers/route-title.provider';

export const resolveTitleFor = (route: Route): (() => Observable<string>) => {
  return () => inject(RouteTitleProvider).entry(route);
};
